import './AppLayout.scss';
import {ProfileContext, initialProfile} from "../context/ProfileContext";
import React, {useEffect, useState} from "react";
import {useKeycloak} from "@react-keycloak/web";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import PublicWelcomePage from "./WelcomePage/PublicWelcomePage";
import PrivateLayout from "./private/PrivateLayout";
import {Typography} from "@mui/material";
import CreateDocument from "./private/CreateDocument/CreateDocument";
import CheckDocument from "./CheckDocument/CheckDocument";
import PublicLayout from "./public/PublicLayout";
import ProfileView from "./private/Profile/ProfileView";
import DocumentList from "./private/DocumentList/DocumentList";
import SubscriptionView from "./private/Subscription/SubscriptionView";
import BuySubscriptionView from "./private/Subscription/BuySubscriptionView";
import InboxView from "./private/Inbox/InboxView";
import ReportsView from "./private/Reports/ReportsView";
import {ePismoClientInstance} from "./private/Service/EPismoClient";
import {GuiMessage} from "../types/GuiMessage";
import GuiMessageModal from "../components/common/GuiMessageModal";

function AppLayout() {

    const [profile, setProfile] = useState(initialProfile);
    const [guiMessages, setGuiMessages] = useState<GuiMessage[]>([]);
    const [currentMessage, setCurrentMessage] = useState<GuiMessage | null>(null);
    const {keycloak, initialized} = useKeycloak();

    const fetchGuiMessages = () => {
        ePismoClientInstance.getGuiMessages(keycloak)
            .then(response => {
                const messages = response.data as GuiMessage[];
                if (messages.length > 0) {
                    setGuiMessages(messages);
                    setCurrentMessage(messages[0]);
                }
            })
            .catch(error => {
                console.error("Błąd podczas pobierania komunikatów GUI:", error);
            });
    }

    useEffect(() => {
        if (initialized && keycloak.authenticated && keycloak.token) {
            keycloak.loadUserProfile().then(p => {
                setProfile(p as any);
            })
            fetchGuiMessages();
        }
    }, [initialized, keycloak.authenticated, keycloak.token])

    const handleAcceptMessage = (id: number) => {
        ePismoClientInstance.acceptGuiMessage(id, keycloak)
            .then(() => {
                const remainingMessages = guiMessages.filter(m => m.id !== id);
                setGuiMessages(remainingMessages);
                if (remainingMessages.length > 0) {
                    setCurrentMessage(remainingMessages[0]);
                } else {
                    setCurrentMessage(null);
                }
            })
            .catch(error => {
                console.error("Błąd podczas akceptowania komunikatu GUI:", error);
            });
    }

    return (
        <ProfileContext.Provider value={profile}>
            <div className="AppLayout">
                <GuiMessageModal message={currentMessage} onAccept={handleAcceptMessage} />
                <BrowserRouter>
                    <Routes>
                        <Route path="/">
                            <Route index element={
                                <div>
                                    {!keycloak.authenticated && <PublicWelcomePage/>}
                                    {keycloak.authenticated && <PrivateLayout element={<ProfileView/>}/>}
                                </div>
                            }/>
                            <Route path="nadaj-pismo" element={
                                <div>
                                    {!keycloak.authenticated && <PublicWelcomePage/>}
                                    {keycloak.authenticated && <PrivateLayout element={<CreateDocument/>}/>}
                                </div>
                            }/>
                            <Route path="skrzynka-odbiorcza" element={
                                <div>
                                    {!keycloak.authenticated && <PublicWelcomePage/>}
                                    {keycloak.authenticated && <PrivateLayout element={<InboxView/>}/>}
                                </div>
                            }/>
                            <Route path="sprawdz-pismo" element={
                                <div>
                                    {!keycloak.authenticated && <PublicLayout element={<CheckDocument/>}/>}
                                    {keycloak.authenticated && <PrivateLayout element={<CheckDocument/>}/>}
                                </div>
                            }/>
                            <Route path="lista-pism" element={
                                <div>
                                    {!keycloak.authenticated && <PublicWelcomePage/>}
                                    {keycloak.authenticated && <PrivateLayout element={<DocumentList/>}/>}
                                </div>
                            }/>
                            <Route path="subskrypcje" element={
                                <div>
                                    {!keycloak.authenticated && <PublicLayout element={<PublicWelcomePage/>}/>}
                                    {keycloak.authenticated && <PrivateLayout element={<SubscriptionView/>}/>}
                                </div>
                            }/>
                            <Route path="raporty" element={
                                <div>
                                    {!keycloak.authenticated && <PublicWelcomePage/>}
                                    {keycloak.authenticated && <PrivateLayout element={<ReportsView/>}/>}
                                </div>
                            }/>
                            <Route path="sprawdz-subskrypcje" element={
                                <div>
                                    {!keycloak.authenticated && <PublicLayout element={<BuySubscriptionView/>}/>}
                                    {keycloak.authenticated && <PrivateLayout element={<BuySubscriptionView/>}/>}
                                </div>
                            } />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </div>
        </ProfileContext.Provider>
    )
}

export default AppLayout;